<template>
  <div class=" bg-white -mt-4">
    <div class="cust_card p-2 m-2 ">
        <div class="flex items-center">
          <p class="heading-3 text-primary cursor-pointer" @click="$router.push({name: 'ProfileDetail'})">Setting</p>
          <p class="heading-3 text-gray3 px-3">></p>
          <p class="heading-3 text-gray4">Amazon selling partner api token details</p>
        </div>
    </div>

    <!-- Instructions Card -->
    <div class="rounded bg-white cust_card m-2 p-4">
      <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <h3 class="text-lg font-semibold text-text1 mb-3 flex items-center">
          <i class="fas fa-info-circle text-primary mr-2"></i>
          How to Update Amazon Client Secret Token
        </h3>
        <ol class="list-decimal list-inside space-y-2 text-text2">
          <li class="pl-2">
            <span class="font-medium">Login</span> to Amazon Seller Central account using <span class="font-semibold text-text1">blaine@petstop.com</span> login credentials.
          </li>
          <li class="pl-2">
            On the top, select <span class="font-semibold text-text1">"Consumer Supplies Direct" > "United States"</span>
          </li>
          <li class="pl-2">
            Left drawer menu > <span class="font-semibold text-text1">"Apps and Services" > "Develop Apps"</span>
          </li>
          <li class="pl-2">
            App name: <span class="font-semibold text-text1">Analytics Portal</span> > click on <span class="font-semibold text-text1">View</span> on the LWA credentials column.
          </li>
          <li class="pl-2">
            Click on <span class="font-semibold text-text1">Rotate secret</span> button.
          </li>
          <li class="pl-2">
            Update the newly generated client secret token in <span class="font-semibold text-text1">"AMAZON_CLIENT_SECRET"</span> and add the next expiry date in the Description field.
          </li>
        </ol>
      </div>
    </div>

    <div class=" rounded px-2 py-2  bg-white cust_card m-2 " style="overflow: visible;">
      <div class="">
        <div class="w-auto" >
        </div>
        <div style="overflow-y: auto; white-space: nowrap;" class="table_containder max-w-max h-full">
          <div class="text-text2  min-w-min heaer_row border border-gray1 font-bold flex heading-7  px-3 py-3 items-center">
            <div class="name_col  flex items-center">
              <span>{{titleObj[0].title}} </span>
            </div>
            <div class="dept_col  flex items-center">
              <span>{{titleObj[1].title}}</span>
            </div>
            <div class="emp_col  flex items-center">
              <span>{{titleObj[2].title}}</span>
            </div>
            <div class="action_col  flex items-center">
              <span>Action</span>
            </div>
          </div>
          <div v-for="(data, index) in userList" :key="index" class="min-w-min flex border-r border-l border-b border-gray1  bg-white  text-sm px-3 py-2 items-center hover:bg-gray-50">
            <div class="name_col">
              <div class="flex items-center">
                <span class="heading-4  text-text1 ">{{data.name}}</span>
              </div>
            </div>
            <div class="dept_col">
              <span class="heading-4 text-text1" v-if="data.value !== ''">{{data.value}}</span>
              <span class="pl-4" v-else>--</span>
            </div>
            <div class="emp_col">
              <span class="heading-4 text-text1" v-if="data.description !== ''">{{data.description}}</span>
              <span class="pl-4" v-else>--</span>
            </div>
            <div class="action_col" @click="openEditDialog(data)">
              <div>
                <i class="fas fa-edit text-primary cursor-pointer"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="layout my-2" v-if="userList.length === 0">
          <div class="flex p-3 text-sm text-primary bg-white border-blue-100 border-2 rounded-lg  items-center" role="alert">
            <svg aria-hidden="true" class="flex-shrink-0 inline w-6 h-6 mr-3" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>
            <span class="sr-only">Info</span>
            <div>
              <p class=" font-medium heading-4">No record found.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit Token Dialog -->
    <div v-if="editDialog" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white rounded-lg shadow-xl p-6 w-full max-w-2xl mx-4">
        <h2 class="text-xl font-bold text-text1 mb-4">Edit Token</h2>

        <div class="space-y-4">
          <!-- Token Input Field -->
          <div>
            <label class="block text-sm font-medium text-text2 mb-2">Token</label>
            <textarea
              v-model="editForm.value"
              class="w-full px-3 py-2 border border-gray1 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
              rows="3"
              placeholder="Enter token"
            ></textarea>
          </div>

          <!-- Description Input Field -->
          <div>
            <label class="block text-sm font-medium text-text2 mb-2">Description</label>
            <textarea
              v-model="editForm.description"
              class="w-full px-3 py-2 border border-gray1 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
              rows="3"
              placeholder="Enter description"
            ></textarea>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="flex justify-end gap-3 mt-6">
          <button
            @click="closeEditDialog"
            class="px-4 py-2 border border-gray1 rounded-md text-text2 hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            @click="saveToken"
            class="px-4 py-2 bg-primary text-white rounded-md hover:bg-primary-dark transition-colors"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import API from '@/api/App.js'
export default {
  components: {
  },
  data () {
    return {
      titleObj: [
        {title: 'Name', icon: 'fas fa-sort-amount-up', sortName: 'staffFirstName', sortVal: 'DESC'},
        {title: 'Token', icon: '', sortName: 'staffCellNumber', sortVal: ''},
        {title: 'Description', icon: '', sortName: 'staffEmail', sortVal: ''},
    ],
      userList: [],
      editDialog: false,
      editForm: {
        optionId: 0,
        name: '',
        value: '',
        description: ''
      }
    }
  },
  mounted () {
    this.getAmzTokenDetail()
    document.title = 'Amazon Token Details'
  },
  watch: {
  },
  methods: {
     getAmzTokenDetail () {
      this.$store.dispatch('SetLoader', {status: true, message: 'Loading...'})
      API.GetTokenDetails(
        response => {
          this.userList = response.Data === null ? [] : response.Data
          this.$store.dispatch('SetLoader', {status: false, message: ''})
        },
        error => {
          this.$store.dispatch('SetLoader', {status: false, message: ''})
          this.$store.dispatch('SetAlert', {showAlert: true, message: error.message, color: 'error'})
        }
      )
    },
    toTop () {
      this.$vuetify.goTo(0)
    },
    openEditDialog (data) {
      console.log('data---', data)
      this.editForm = {
        optionId: data.optionId || 0,
        name: data.name || '',
        value: data.value || '',
        description: data.description || ''
      }
      console.log('this.editDialog--111-', this.editDialog)
      this.editDialog = true
      console.log('this.editDialog--222-', this.editDialog)
    },
    closeEditDialog () {
      this.editDialog = false
      this.editForm = {
        optionId: 0,
        name: '',
        value: '',
        description: ''
      }
    },
    saveToken () {
      if (!this.editForm.value.trim()) {
        this.$store.dispatch('SetAlert', {showAlert: true, message: 'Token is required', color: 'error'})
        return
      }

      this.$store.dispatch('SetLoader', {status: true, message: 'Saving...'})
      const payload = {
        optionId: this.editForm.optionId,
        name: this.editForm.name,
        value: this.editForm.value,
        description: this.editForm.description
      }

      API.AmzTokenUpdate(
        payload,
        response => {
          console.log('response', response)
          this.$store.dispatch('SetLoader', {status: false, message: ''})
          this.$store.dispatch('SetAlert', {showAlert: true, message: 'Token updated successfully', color: 'success'})
          this.closeEditDialog()
          this.getAmzTokenDetail()
        },
        error => {
          this.$store.dispatch('SetLoader', {status: false, message: ''})
          this.$store.dispatch('SetAlert', {showAlert: true, message: error.message || 'Failed to update token', color: 'error'})
        }
      )
    }
  },
  beforeDestroy () {
  }
}
</script>
<style scoped>
.table_containder {
  padding: 1px;
}
.name_col {
  min-width: 250px !important;
  width: 250px !important;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
}
.dept_col {
  min-width: 850px !important;
  width: 850px !important;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
}
.emp_col {
  min-width: 520px !important;
  width: 520px !important;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
}
.action_col {
  min-width: 100px !important;
  width: 100px !important;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
  text-align: center;
}

@keyframes indeterminateAnimation {
  0% {
    transform:  translateX(0) scaleX(0);
  }
  40% {
    transform:  translateX(0) scaleX(0.4);
  }
  100% {
    transform:  translateX(100%) scaleX(0.5);
  }
}
::placeholder {
  font-size: 16px;
}
.searchInput {
  height: 42px;
}
</style>
